/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { TextInput, TextInputType as ConsumerTextInputType } from '@blend/consumer-components';
import MaskedInput from '@blend/react-text-mask';
import { InputWrapperProps, TextInputType } from './types';

type Normalizer = (value: React.ReactText) => string;

interface InputMask {
  normalize?: Normalizer;
  maskedInputConfig: {};
}

export interface TextInputWrapperConfig {
  type?: TextInputType;
  mask?: InputMask;
  forceNumericKeyboard?: boolean;
  autoFocus?: boolean;
}

export const TextInputWrapper = (textInputWrapperConfig: TextInputWrapperConfig = {}) => {
  const { type = 'text', forceNumericKeyboard, mask } = textInputWrapperConfig;
  let inputComponent: (props: any) => JSX.Element;
  if (mask) {
    inputComponent = (props: any) => {
      return <MaskedInput {...props} {...mask.maskedInputConfig} />;
    };
  }
  return ({ input, meta, ...htmlProps }: InputWrapperProps) => (
    <TextInput
      {...input}
      {...htmlProps}
      inputComponent={inputComponent}
      type={(forceNumericKeyboard ? 'tel' : type) as ConsumerTextInputType}
      hasError={!!(meta.touched && meta.error)}
    />
  );
};

export const UnformattedTextInput = TextInputWrapper();
